module.exports = __webpack_public_path__ + "img/samaritan.b477d388.png";